/* tslint:disable */
/* eslint-disable */
export enum ArkUserType {
  Admin = 1,
  Marketing = 2,
  Support = 3,
  Developer = 4,
  Impersonator = 5
}
